import { Maybe } from 'graphql/jsutils/Maybe';
import { FoodType, Holiday } from 'src/gqlReactTypings.generated.d';
import { KID_FOOD_TYPES, MAIN_FOOD_TYPES, SIDE_FOOD_TYPES } from 'src/shared/Constants';
import { match, P } from 'ts-pattern';
import { Section } from './consts';

export const getHolidaySection = (holiday: Holiday) =>
  match(holiday)
    .with(Holiday.Diwali, () => Section.Diwali)
    .with(Holiday.Thanksgiving, () => Section.Thanksgiving)
    .with(Holiday.Hanukkah, () => Section.Hanukkah)
    .with(Holiday.Christmas, () => Section.Christmas)
    .with(Holiday.Kwanzaa, () => Section.Kwanzaa)
    .with(Holiday.Holi, () => Section.Holi)
    .with(Holiday.LunarNewYear, () => Section.LunarNewYear)
    .with(Holiday.Easter, () => Section.Easter)
    .with(Holiday.NewYear, () => Section.NewYear)
    .with(Holiday.Valentines, () => Section.Valentines)
    .with(Holiday.Nowruz, () => Section.Nowruz)
    .with(Holiday.Ramadan, () => Section.Ramadan)
    .with(Holiday.EidAlFitr, () => Section.EidAlFitr)
    .with(Holiday.Vesak, () => Section.Vesak)
    .exhaustive();

export const getFoodTypeSection = (foodType: Maybe<FoodType>) =>
  match(foodType)
    .when(
      (s) => MAIN_FOOD_TYPES.includes(s),
      () => Section.Main
    )
    .when(
      (s) => SIDE_FOOD_TYPES.includes(s),
      () => Section.Side
    )
    .when(
      (s) => KID_FOOD_TYPES.includes(s),
      () => Section.Kids
    )
    .otherwise(() => Section.Drop);

export const getMainItemsLabel = ({ isUnavailable = false, isSmallScreen = false, deliveryDateTime }) =>
  match({ isUnavailable, isSmallScreen, deliveryDateTime })
    .with({ isUnavailable: true }, () => 'SAMPLE MENU')
    .with({ isSmallScreen: true }, () => 'MAIN ITEMS')
    .with({ deliveryDateTime: P.when((deliveryDateTime) => deliveryDateTime === undefined) }, () => 'MAIN ITEMS')
    .otherwise(() => `${deliveryDateTime.weekdayLong.toUpperCase()}'S MAIN ITEMS`);

export const getSideItemsLabel = ({ isUnavailable = false, isSmallScreen = false, deliveryDateTime }) =>
  match({ isUnavailable, isSmallScreen, deliveryDateTime })
    .with({ isUnavailable: true }, () => 'SAMPLE SIDES')
    .with({ isSmallScreen: true }, () => 'SIDE ITEMS')
    .with({ deliveryDateTime: P.when((deliveryDateTime) => deliveryDateTime === undefined) }, () => 'SIDE ITEMS')
    .otherwise(() => `${deliveryDateTime.weekdayLong.toUpperCase()}'S SIDE ITEMS`);
